import React from "react";

const WorkItem = ({ project }) => {
  return (
    <div className="work__card" key={project.id}>
      <img src={project.image} alt="" className="work__img" />
      <h3 className="work__card-title">{project.title}</h3>
      <p className="work__description">{project.description}</p>
    </div>
  );
};

export default WorkItem;
